import React from 'react';
import classNames from 'classnames';

interface Props {
  onClick?: () => void;
  customClasses?: string;
  disabled?: boolean;
  loading?: boolean;
}

export function LoadMoreBtn({ onClick, customClasses, disabled, loading }: Props) {
  return (
    <div
      className={classNames(
        'flex w-full my-10 items-center justify-center',
        customClasses
      )}
    >
      <button
        type="button"
        onClick={onClick}
        disabled={disabled || loading}
        className="bg-surface-2 text-text-1 px-6 py-2 rounded-xl hover:bg-track disabled:opacity-50"
      >
        {loading ? 'Loading...' : 'Load More'}
      </button>
    </div>
  );
}
